const EquipmentContants = {
  DELETE_EQUIPMENT_SUCCESS: "DELETE_EQUIPMENT_SUCCESS",
  DELETE_EQUIPMENT_FAILURE: "DELETE_EQUIPMENT_FAILURE",
  COPY_EQUIPMENT_SUCCESS: "COPY_EQUIPMENT_SUCCESS",
  COPY_EQUIPMENT_FAILURE: "COPY_EQUIPMENT_FAILURE",
  GET_EQUIPMENTFORM_SUCCESS: "GET_EQUIPMENTFORM_SUCCESS",
  GET_EQUIPMENTFORM_FAILURE: "GET_EQUIPMENTFORM_FAILURE",
  INSERT_NEWEQUIPMENT_SUCCESS: "INSERT_NEWEQUIPMENT_SUCCESS",
  INSERT_NEWEQUIPMENT_FAILURE: "INSERT_NEWEQUIPMENT_FAILURE",
  GET_EQUIPMENTDETAILS_SUCCESS: "GET_EQUIPMENTDETAILS_SUCCESS",
  GET_EQUIPMENTDETAILS_FAILURE: "GET_EQUIPMENTDETAILS_FAILURE",
  UPDATE_EQUIPMENTSTATUS_SUCCESS: "UPDATE_EQUIPMENTSTATUS_SUCCESS",
  UPDATE_EQUIPMENTSTATUS_FAILURE: "UPDATE_EQUIPMENTSTATUS_FAILURE",
  UPDATE_EQUIPMENT_SUCCESS: "UPDATE_EQUIPMENT_SUCCESS",
  UPDATE_EQUIPMENT_FAILURE: "UPDATE_EQUIPMENT_FAILURE",
  SAVE_EQUIPMENT_IMAGES_SUCCESS: "SAVE_EQUIPMENT_IMAGES_SUCCESS",
  SAVE_EQUIPMENT_IMAGES_FAILURE: "SAVE_EQUIPMENT_IMAGES_FAILURE",
  SET_EQUIPMENT_DEFAULT_IMAGE_SUCCESS: "SET_EQUIPMENT_DEFAULT_IMAGE_SUCCESS",
  SET_EQUIPMENT_DEFAULT_IMAGE_FAILURE: "SET_EQUIPMENT_DEFAULT_IMAGE_FAILURE",
  SCRAP_EQUIPMENT_SUCCESS: "SCRAP_EQUIPMENT_SUCCESS",
  SCRAP_EQUIPMENT_FAILURE: "SCRAP_EQUIPMENT_FAILURE",
  GET_EQUIPMENT_SCRAP_IMAGES_SUCCESS: "GET_EQUIPMENT_SCRAP_IMAGES_SUCCESS",
  GET_EQUIPMENT_SCRAP_IMAGES_FAILURE: "GET_EQUIPMENT_SCRAP_IMAGES_FAILURE",
};
export default EquipmentContants;
